import { Grid } from '@mui/material';

interface Props {
  text: string;
  color: string;
  backgroundColor: string;
}

export const ColouredInputBox = ({ text, color, backgroundColor }: Props) => {
  return (
    <Grid container>
      <Grid
        item
        style={{
          color: color,
          backgroundColor: backgroundColor,
          padding: '0em 0.5em',
          border: `1px solid ${color}`,
          borderRadius: '0.25em'
        }}
      >
        {text}
      </Grid>
    </Grid>
  );
};
